import { render, staticRenderFns } from "./overall-collection-metrics.vue?vue&type=template&id=51ab9c44&"
import script from "./overall-collection-metrics.vue?vue&type=script&lang=js&"
export * from "./overall-collection-metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "overall-collection-metrics.vue"
export default component.exports